import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";

const HomePage = () => {
  const { user, isLogged, isAuthChecking } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthChecking) {
      return;
    }

    if (!isLogged || !user) {
      navigate("/login", { replace: true });
      return;
    }

    if (user.role === 1) {
      navigate("/users", { replace: true });
    } else if (user.role === 2) {
      navigate("/surveillance", { replace: true });
    } else {
      navigate("/login", { replace: true });
    }
  }, [user, isLogged, isAuthChecking, navigate]);

  return null;
};

export default HomePage;